import { LoginPage } from "./ui/login.page";

export default LoginPage;
